void import("./flyout.ts").then(({ initFlyout }) => {
    initFlyout()
})
